<div class="flex flex-row">
  @if (leftLabel()) {
    <span class="mr-2 font-semibold">{{ leftLabel() }}</span>
  }
  <button
    type="button"
    role="switch"
    [attr.aria-checked]="checked()"
    [disabled]="disabled()"
    class="flex relative items-center justify-start cursor-pointer p-0 h-6 w-11 rounded-full transition-colors duration-200 border-outline border-1"
    [style.background]="
      checked() ? 'linear-gradient(135deg, var(--primary) 0%, #dc2626 100%)' : null
    "
    [class.bg-surface-container-highest]="!checked()"
    (click)="toggle(!checked())"
  >
    <span
      class="inline-block ml-1 h-4 w-4 transform rounded-full transition duration-200 text--on-primary"
      [class.translate-x-5]="checked()"
      [class.bg-on-primary]="checked()"
      [class.bg-outline]="!checked()"
    >
      @if (checked()) {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          viewBox="0 0 16 16"
        >
          <path
            d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"
          />
        </svg>
      }
    </span>
  </button>
  @if (rightLabel()) {
    <span class="ml-2">{{ rightLabel() }}</span>
  }
</div>
